import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconClock2 = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" {...props} ref={ref}>
    <path
      d="M8 1.46875C11.6819 1.46875 14.667 4.45384 14.667 8.13574C14.667 11.8176 11.6819 14.8027 8 14.8027C4.3181 14.8027 1.33301 11.8176 1.33301 8.13574C1.33301 4.45384 4.3181 1.46875 8 1.46875ZM8 2.68164C4.98754 2.68164 2.5459 5.12328 2.5459 8.13574C2.5459 11.1482 4.98754 13.5898 8 13.5898C11.0125 13.5898 13.4541 11.1482 13.4541 8.13574C13.4541 5.12328 11.0125 2.68164 8 2.68164ZM8 3.89355C8.3346 3.89355 8.60625 4.16447 8.60645 4.49902V7.76074L10.6953 8.80566C10.9947 8.95535 11.1165 9.31976 10.9668 9.61914C10.8171 9.91852 10.4527 10.0393 10.1533 9.88965L7.72852 8.67773C7.52342 8.575 7.39355 8.36516 7.39355 8.13574V4.49902C7.39375 4.16447 7.6654 3.89355 8 3.89355Z"
      fill="currentColor"
    />
  </svg>
)

export const IconClock2 = forwardRef(_IconClock2)
